import { isValidPhoneNumber } from "libphonenumber-js/min";

export const isValidPhone = (phone: string): boolean =>
  isValidPhoneNumber(phone);
